interface IFixedRightBottom {
  backTop?: {
    scrollContainer: string
    item: string
    top?: number
    total?: Ref<number> | number
  }
  // contactUs: boolean
  onlineService: boolean
}

export const useFixedRightBottom = () =>
  useState<IFixedRightBottom>('fixed-right-bottom', () => ({
    // contactUs: true,
    onlineService: true,
  }))

export const useBackToTop = (fn: () => IFixedRightBottom['backTop']) => {
  const option = useFixedRightBottom()

  watchEffect(() => {
    option.value.backTop = fn()
  })

  onBeforeRouteLeave(() => {
    option.value.backTop = undefined
  })

  onBeforeRouteUpdate(() => {
    option.value.backTop = undefined
  })
}
